<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#placements" @click="activeComponent='tabPlacements'"><i class="fa fa-link"></i> Placed links</a></li>
        <li v-if="user.admin || user.roles.includes('links')"><a class="nav-link" data-toggle="tab" href="#build" @click="activeComponent='tabBuild'"><i class="fas fa-map-pin"></i> Build Links</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row" v-if="activeComponent">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Placements from './Tabs/Placements'
import Build from './Tabs/Build'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      activeComponent: 'tabPlacements'
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  components: {
    tabPlacements: Placements,
    tabBuild: Build
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order/Content.vue